import React from 'react';
import componentProps, { ComponentProps } from '../../../../../helpers/componentProps';
import { applyComponentTheme } from '../../../../../theme';
import { LabelWrapper, StyledLabel } from './styles';

type LabelProps = {
  htmlFor: string;
  children?: React.ReactNode;
} & ComponentProps;

const Label: React.FC<LabelProps> = ({ htmlFor, children, ...rest }) => (
  <LabelWrapper {...componentProps(rest)}>
    <StyledLabel htmlFor={htmlFor}>{children}</StyledLabel>
  </LabelWrapper>
);

export default applyComponentTheme(Label, 'Label');
